<template>
  <layout :drawerShow="true" :drawerWidth="350">
    <template slot="nav">
      <v-tabs>
        <v-tab>Appels</v-tab>
      </v-tabs>
    </template>
    <template slot="nav-tools">

    </template>
    <template slot="drawer">
      <div>
        <v-form ref="searchform" v-if="searchform" v-on:submit.prevent="valid">
          <v-row dense>
            <v-col cols="12">
              <v-subheader light class="pa-0 ml-1">Dates d'appel</v-subheader>
            </v-col>
            <v-col class="pr-1" cols="6">
              <smart-picker
                  v-model="searchform.startDate"
                  :stopDate="searchform.stopDate"
                  :inputOpts="{ label: $t('begin') }"
              />
            </v-col>
            <v-col cols="6">
              <smart-picker
                  v-model="searchform.stopDate"
                  :startDate="searchform.startDate"
                  :inputOpts="{ label: $t('end') }"
              />
            </v-col>
            <v-col cols="6" class="mt-3">
              <v-select v-if="users"
                        v-model="searchform.userId"
                        label="Utilisateurs"
                        item-text="name"
                        item-value="id"
                        :items="users"
                        clearable
              />
            </v-col>
            <v-col cols="6" class="mt-3">
              <v-select
                  v-model="searchform.siteId"
                  label="Sites"
                  item-text="name"
                  item-value="id"
                  :items="sites"
                  clearable
              />
            </v-col>
            <v-col cols="12" class="">
              <v-select
                  dense
                  v-model="searchform.categories"
                  label="Categories"
                  item-text="value"
                  item-value="key"
                  placeholder="Categorie"
                  :items="categories"
                  multiple
                  clearable
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                  dense
                  v-model="searchform.phoneNumber"
                  label="Numéro de Tel."
                  type="number"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                  dense
                  v-model="searchform.terms"
                  label="Termes à retrouver"
                  placeholder="Séparés par une virgule"
              />
            </v-col>

            <v-col cols="6" align-self="end">
              <v-switch dense v-model="searchform.transcripted" label="Transcris"></v-switch>
            </v-col>
          </v-row>
          <smart-btn type="submit" block primary class="mt-2" :loading="loading"
          >Rechercher
          </smart-btn
          >
          <smart-btn
              block
              tertiary
              @click.native="
            clearSearchform();
          "
          >Réinitialiser la recherche
          </smart-btn
          >
        </v-form>
      </div>
    </template>
    <template slot="content">
      <v-container fluid class="m-4 ">
        <v-data-table
            style="word-break: break-word;"
            v-model="datatable.selectedCalls"
            item-key="id"
            show-expand
            :expanded.sync="datatable.expanded"
            dense
            :loading="loading"
            :headers="datatable.headers"
            :items="datatable.listCalls"
            :items-per-page="-1"
            no-data-text="Il n'y a pas d'appel disponible"
            class="elevation-1 tbl pr-1"
            hide-default-footer
        >
          <template #item.data-table-expand="{ item, internalItem, expand, isExpanded }">
            <td class="text-start">
              <div class="d-flex">
                <div class="d-flex">
                  <v-menu v-bind="menuOpts" rounded>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
                    </template>

                    <v-list dense>
                      <v-list-item :disabled="item.transcription != null" class="body-2"
                                   @click="regenTranscription(item.id)">
                        <v-icon small class="mr-2">mdi-script-text-play-outline</v-icon>
                        Générer transcription
                      </v-list-item>
                      <v-list-item class="body-2" :disabled="!item.leadId" @click="toLead(item.leadId)">
                        <v-icon small class="mr-2">mdi-open-in-new</v-icon>
                        Voir le lead
                      </v-list-item>
                      <v-list-item class="body-2" :disabled="item.leadId != null"
                                   @click="createLead(item)">
                        <v-icon small class="mr-2">mdi-layers</v-icon>
                        Créer un lead
                      </v-list-item>

                    </v-list>
                  </v-menu>
                </div>
                <div v-if="item.FILES.length > 0">
                  <v-btn fab small
                         raised elevation="0"
                         style="background-color: white"
                         @click="expand(!isExpanded), getTranscription(isExpanded,item)"
                         class="v-data-table__expand-icon"
                         :class="{ 'v-data-table__expand-icon--active': isExpanded }"
                  >
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </div>
              </div>
            </td>
          </template>

          <template v-slot:item.user="{ value }">
                <span>{{ value && value.name ? value.name : '-' }}
                </span>
          </template>

          <template v-slot:item.createdDate="{ value }">
            <div class="d-flex flex-column">
              <span>{{ value.day }}</span>
              <span class="grey--text  lighten-2 caption">{{ value.hour }}</span>
            </div>
          </template>
          <template v-slot:item.virtualSite="{value,item}">
            <div class="d-flex flex-column my-1">
              <span class="caption grey--text lighten-1">#{{ item.id }}</span>
              <site-label :sitename="value" v-if="value"></site-label>
              <span v-else> - </span>

            </div>
          </template>
          <template v-slot:item.FILES="{value}">
            <!--            <v-tooltip top v-if="value.length > 0">
                          <template v-slot:activator="{ on }">
                            <a :href="value" v-on="on">-->
            <v-icon v-if="value.length > 0" color="teal lighten-2" @click="openAudioDialog(value)">
              mdi-file-cloud-outline
            </v-icon>
            <v-tooltip top v-else>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="grey lighten-1">mdi-file-cancel-outline</v-icon>
              </template>
              Aucun fichier audio
            </v-tooltip>

          </template>
          <template v-slot:item.categories="{value, item}">
            <div>
              {{ getCategory(value) }}
            </div>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length-1">
              <v-row>
                <v-col cols="9">
                  <span v-if="transcriptEmpty != null && item.transcription == null">
                    {{ transcriptEmpty }}
                  </span>
                  <Chatting v-if="item && item.transcription" :transcription="item.transcription" inline/>
                </v-col>
                <v-col cols="3" class="pt-7">
                  <div class="d-flex flex-column">
                    <smart-btn block class="" v-if="item.transcription != null && item.FILES.length > 0" elevation="0"
                               small
                               @click.native="regenTranscription(item.id)">
                      <v-icon class="mr-1">mdi-update</v-icon>
                      Regen transcription
                    </smart-btn>

                    <smart-btn block class="my-2"
                               v-if="item.transcription != null && item.FILES.length > 0 && item.leadId != null"
                               elevation="0" small
                               @click.native="resumeTranscription(item.id, item.leadId)">
                      <v-icon class="mr-1">mdi-script-text-key-outline</v-icon>
                      Gen résumé
                    </smart-btn>

                    <v-divider class="mt-5"/>

                    <v-select v-model="wiki.selectedModel" :items="llms" item-text="name" return-object
                              label="Choix LLM Wiki" small-chips dense hide-details class="mt-5">
                      <template #item="{item}">
                        {{ item.name }} -
                        {{ item.price_in }}€ / {{ item.price_out }}€ /M tk
                        Score: {{ item.score }}
                      </template>
                    </v-select>

                    <smart-btn block class="my-2"
                               v-if="item.transcription != null "
                               elevation="0" small
                               @click.native="genWiki(item.id)">
                      <v-icon class="mr-1">mdi-script-text-key-outline</v-icon>
                      Gen wiki
                    </smart-btn>
                  </div>
                </v-col>
              </v-row>
            </td>
          </template>

        </v-data-table>


      </v-container>
      <smart-dialog v-model="creationLeadDialog" title="Créer un lead">
        <LeadCreationDialog :userList="users" :lead-info="leadInfos" @lead-created="()=>closeCreationLeadDialog()"/>
        <template title="actions">
          <v-card-actions class="actions-btn mt-4">
            <v-spacer/>
            <smart-btn type="submit" form="creation-lead">
              <v-icon small class="mr-1">mdi-content-save</v-icon>
              Créer
            </smart-btn>
          </v-card-actions>
        </template>
      </smart-dialog>

      <smart-dialog v-model="audio.dialog" title="Fichier audio">
        <div class="d-flex pa-4 justify-space-around">
          <audio controls>
            <source :src="audio.file" type="audio/mpeg">
            <div class="d-flex flex-column">
              <span>Votre navigateur n'est pas compatible</span>
              <a :href="audio.file">
                <v-icon small>mdi-download-outline</v-icon>
                Télécharger le fichier</a>
            </div>
          </audio>

        </div>
      </smart-dialog>

      <smart-dialog v-model="wiki.dialog" title="Wiki" width="1200">
        <div class="d-flex pa-4 justify-space-around">
          <div v-if="wiki.dialog && wiki.wikiResponse">
            <div v-if="wiki.error == null">
              <v-btn small @click="copyWikiResp()">Copier</v-btn>
              <v-btn small @click="dlWikiResp()">Télécharger</v-btn>
            </div>
            <span v-if="wiki.error != null">{{ wiki.error }}</span>

            <v-divider class="my-5"/>
            <vue-json-pretty
                v-if="wiki.error == null"
                :data="wiki.wikiResponse"
                showIcon
                showDoubleQuotes
            >
            </vue-json-pretty>
          </div>
          <span v-else>
            Chargement...
          </span>
        </div>
      </smart-dialog>

    </template>
  </layout>
</template>
<script>
import FormMixin from "@/components/mixins/FormMixin";
import Layout from "@/views/Layout";
import {get, post} from "@/utils/api";
import SiteLabel from "@/components/commons/SiteLabel.vue";
import Chatting from "@/components/commons/Chatting.vue";
import {EventBus} from "@/components/commons/event-bus";
import LeadCreationDialog from "@/views/lead/LeadCreationDialog.vue";
import User from "@/utils/user";
import SmartSelect from "@/components/commons/SmartSelect.vue";
import clipboard from "@/utils/clipboard";
import VueJsonPretty from "vue-json-pretty";


export default {
  name: "PhoneCalls",
  components: {
    SmartSelect,
    LeadCreationDialog,
    Chatting,
    SiteLabel,
    Layout,
    VueJsonPretty
  },
  mixins: [FormMixin],
  data() {
    return {
      menuOpts: {
        "close-on-content-click": true,
        transition: "scale-transition",
        "offset-y": true,
      },
      defaultSearchform: {
        startDate: this._formatDate(new Date(), "dd/MM/yyyy"),
        stopDate: this._formatDate(new Date(), "dd/MM/yyyy"),
        userId: null,
        phoneNumber: null,
        categories: [],
        siteId: null,
        transcripted: true,
        terms: null
      },
      searchform: {},
      users: [],
      datatable: {
        headers: [
          {
            text: "Site",
            value: "virtualSite",
            align: "left",
            sortable: true
          },
          {
            text: "Tel.",
            value: "phoneNumber",
            align: "left",
            sortable: true
          },
          {
            text: "Client",
            value: "client",
            align: "left",
            sortable: true
          },
          {
            text: "User",
            value: "user",
            align: "left",
            sortable: true
          },
          {
            text: "Date",
            value: "createdDate",
            align: "left",
            sortable: true
          },
          {
            text: "Categorie",
            value: "categories",
            align: "left",
            sortable: false
          },
          {
            text: "Fichiers",
            value: "FILES",
            align: "left",
            sortable: true,
            width: 100,
          },
          {text: "Actions", value: "data-table-expand", align: "right", width: 75},

        ],
        selectedCalls: [],
        listCalls: [],
        expanded: [],
      },
      loading: false,
      audio: {
        dialog: false,
        file: ""
      },
      wiki: {
        error: null,
        dialog: false,
        wikiResponse: null,
        selectedModel: {
          "name": "Claude 4.5 Sonnet",
          "code": "claude-sonnet-4-5-20250929",
          "price_in": 3.00,
          "price_out": 15.00,
          "score": 1453
        }
      },
      sites: [],
      categories: [
        {
          key: "Payment",
          value: "Paiement",
          icon: "mdi-cash-multiple"
        },
        {
          key: 'Reinsurance',
          value: "Réassurance",
          icon: "mdi-shield-home-outline"
        },
        {
          key: "Formalities",
          value: "Formalités",
          icon: "mdi-list-box-outline"
        },
        {
          key: "InfoBooking",
          value: "Informations réservation",
          icon: "mdi-cart-check"
        },
        {
          key: "InfoQuote",
          value: "Information devis",
          icon: "mdi-cart-arrow-down"
        },
        {
          key: "Other",
          value: "Autre",
          icon: "mdi-chat-question-outline"
        },
        {
          key: "Advice",
          value: "Conseil",
          icon: "mdi-cash-multiple"
        },
        {
          key: "Technical",
          value: "Question technique",
          icon: "mdi-shield-home-outline"
        },
        {
          key: -1,
          value: "Non enregistré",
          icon: "mdi-content-save-off-outline"
        },
      ],
      itemToCategories: null,
      creationLeadDialog: false,
      leadInfos: null,
      connectedUser: this.currentUser,
      transcriptEmpty: null,
      llms: [
        {"name": "Claude Opus 4.6", "code": "claude-opus-4-6", "price_in": 5.00, "price_out": 25.00, "score": 1498},
        {"name": "Claude Opus 4.7", "code": "claude-opus-4-7", "price_in": 5.00, "price_out": 25.00, "score": 1491},
        {"name": "Gemini 3.5 Flash", "code": "gemini-3.5-flash", "price_in": 1.50, "price_out": 9.00, "score": 1480},
        {"name": "GPT-5.5", "code": "gpt-5.5", "price_in": 5.00, "price_out": 30.00, "score": 1475},
        {
          "name": "Claude Opus 4.5",
          "code": "claude-opus-4-5-20251101",
          "price_in": 5.00,
          "price_out": 25.00,
          "score": 1468
        },
        {"name": "Claude Sonnet 4.6", "code": "claude-sonnet-4-6", "price_in": 3.00, "price_out": 15.00, "score": 1466},
        {
          "name": "Claude 4.5 Sonnet",
          "code": "claude-sonnet-4-5-20250929",
          "price_in": 3.00,
          "price_out": 15.00,
          "score": 1453
        },
        {"name": "Gemini 2.5 Pro", "code": "gemini-2.5-pro", "price_in": 1.25, "price_out": 10.00, "score": 1448},
        {"name": "GPT-5.1", "code": "gpt-5.1", "price_in": 1.25, "price_out": 10.00, "score": 1439},
        {
          "name": "Gemini 3.1 Flash Lite",
          "code": "gemini-3.1-flash-lite",
          "price_in": 0.25,
          "price_out": 1.50,
          "score": 1438
        },
        {"name": "GPT-5.2", "code": "gpt-5.2", "price_in": 1.75, "price_out": 14.00, "score": 1437},
        {"name": "GPT-5", "code": "gpt-5", "price_in": 1.25, "price_out": 10.00, "score": 1434},
        {"name": "GPT-4.1", "code": "gpt-4.1", "price_in": 2.00, "price_out": 8.00, "score": 1413},
        {"name": "Gemini 2.5 Flash", "code": "gemini-2.5-flash", "price_in": 0.30, "price_out": 2.50, "score": 1411},
        {
          "name": "Claude 4.5 Haiku",
          "code": "claude-haiku-4-5-20251001",
          "price_in": 1.00,
          "price_out": 5.00,
          "score": 1409
        },
        {
          "name": "Qwen3 Next 80B A3B",
          "code": "qwen3-next-80b-a3b",
          "price_in": 0.15,
          "price_out": 1.20,
          "score": 1402
        },
        {"name": "GPT-5 mini", "code": "gpt-5-mini", "price_in": 0.25, "price_out": 2.00, "score": 1390},
        {
          "name": "Gemini 2.5 Flash-Lite",
          "code": "gemini-2.5-flash-lite",
          "price_in": 0.10,
          "price_out": 0.40,
          "score": 1380
        },
        {"name": "gpt-oss-120b", "code": "gpt-oss-120b", "price_in": 0.15, "price_out": 0.60, "score": 1353},
        {"name": "Qwen3 32B", "code": "qwen3-32B", "price_in": 0.15, "price_out": 0.60, "score": 1347}
      ]
    }
  },
  mixin: [User],
  created() {
    this.init()
  },
  methods: {
    init() {
      const loadUsers = get("/api/search/users").json(rs => {
        const res = rs.filter(u => u.groups.some(g => g.id == 3))

        if (this.isAdmin) {
          this.users = [{name: "Tous", id: -1}, ...res]
        } else {
          this.users = [this.currentUser]
        }
      })

      const sites = get('/api/search/sites').json(rs => {
        this.sites = rs
      })

      Promise.all([
        loadUsers, sites
      ]).then(() => {
        this.initSearchform();
        this.loadData()
      });
    },
    initSearchform() {
      const qs = new URLSearchParams(window.location.search);
      const search = (() => {
        try {
          let searchCtx = JSON.parse(qs.get("search"));
          return {
            ...this.defaultSearchform,
            ...searchCtx,
            startDate: this._formatDate(new Date(searchCtx.startDate), "dd/MM/yyyy"),
            stopDate: this._formatDate(new Date(searchCtx.stopDate), "dd/MM/yyyy"),
            userId: this.isAdmin ? (searchCtx.userId ? searchCtx.userId : -1) : this.currentUser.id
          }
        } catch (e) {
          return null;
        }
      })();
      if (search) {
        this.searchform = search
      } else this.clearSearchform();
    },
    getCalls(searchForm) {
      post("/api/phonecall/search", {...searchForm}).json((res) => {
        this.datatable.listCalls = res.map(rs => {
          return {
            ...rs,
            client: rs.client.trim() == "" ? '-' : rs.client,
            createdDate: {
              day: this._formatDate(new Date(rs.createdDate), "dd/MM/yyyy"),
              hour: this._formatDate(new Date(rs.createdDate), "HH:mm")

            }
          }
        })

        this.loading = false
      })
    },
    valid() {
      if (this.$refs.searchform.validate()) {
        this.loadData()
      }
    },
    loadData() {
      this.datatable.listCalls = [];
      this.loading = true
      const body = {
        ...this.searchform,
        startDate: this._parseAndFormatDate(this.searchform.startDate, "dd/MM/yyyy", "yyyy-MM-dd"),
        stopDate: this._parseAndFormatDate(this.searchform.stopDate, "dd/MM/yyyy", "yyyy-MM-dd"),
      }

      if (this.isAdmin && this.searchform.userId === -1) {
        body.userId = null
      }

      window.history.pushState(
          "",
          "",
          "?search=" + JSON.stringify(body)
      );

      this.getCalls(body);
    },
    clearSearchform() {
      this.searchform = {...this.defaultSearchform};
    },
    openAudioDialog(item) {
      this.audio = {
        file: item[0],
        dialog: true
      }
    },
    regenTranscription(id) {
      get(`/api/phonecall/regen/transcription/${id}`)
    },

    genWiki(id) {

      this.wiki = {
        ...this.wiki,
        dialog: true,
        wikiResponse: null,
      }

      return get(`/api/phonecall/${id}/wikify-transcription/${this.wiki.selectedModel.code}`)
      .json(resp => {
        const json = resp.trim().replace(/^```json\s*/i, '').replace(/^```\s*/, '').replace(/```\s*$/, '').trim();
        try {
          this.wiki.wikiResponse = JSON.parse(json)
          console.log(this.wiki.error)
        } catch (err) {
          console.error('JSON invalid:', json);
          this.wiki.error = "JSON Invalide"
          throw err;
        }
      })
    },

    copyWikiResp() {
      clipboard.copyTextToClipboard(JSON.stringify(this.wiki.wikiResponse));
    },
    dlWikiResp() {
      const blob = new Blob([JSON.stringify(this.wiki.wikiResponse)], {type: 'text/plain;charset=utf-8'});
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'wiki.json';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      URL.revokeObjectURL(url);
    },

    getCategory(value) {
      return value.length > 0 ? value[0].category : "non enregistré"
    },
    toLead(id) {
      let route = this.$router.resolve({
        name: "lead",
        params: {id: id},
      });
      window.open(route.href, "_blank");
    },
    createLead(phoneCall) {
      this.leadInfos = {
        ...phoneCall,
        source: 'phone',
        status: 'open',
        score: 2,
        site: phoneCall.virtualSite,
        phonecalls: 1,
        destinations: [],
        id: null,
        phoneCallId: phoneCall.id,
        client_id: phoneCall.clientId,
      }

      this.creationLeadDialog = true
    },
    resumeTranscription(transcriptionId, leadId) {
      EventBus.$emit('snackbarTranscription', {
        show: true,
        done: false,
        leadId: leadId
      })

      post(
          `/api/phonecall/${transcriptionId}/summarize-transcription/lead/${leadId}`
      ).res(() => {
        EventBus.$emit('snackbarTranscription', {
          show: true,
          done: true,
          leadId: leadId
        })
      })
    },
    closeAndReload() {
      this.itemToCategories = null
      this.init()
    },
    getTranscription(alreadyExpanded, item) {
      this.transcriptEmpty = null
      if (item.transcription != null || alreadyExpanded) {
        return null
      } else {
        get(`/api/phonecall/${item.id}/get-transcription`).json((rs) => {
          item.transcription = rs
          return item

        }).catch((err) => {
          if (err.toString().includes('Transcription is empty')) {
            this.transcriptEmpty = "Cet appel n'a pas encore été transcrit"
            return null
          } else {
            console.error(err)
          }
        })

      }
    },
    closeCreationLeadDialog() {
      this.leadInfos = null
      this.creationLeadDialog = false
      this.init()
    }
  }
}
</script>